import axios from 'axios';
import DateUtils from '../utils/date.utils';
import CurrencyUtils from '../utils/currency.utils';

const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

export default class DonGrafServices {
  static async get(refundId) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
      const res = await axios.get(`${ADMIN_URL}/dongraf/${refundId}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (res.status === 200) {
        const results = res.data.data;
        console.log(results);
        if (results.rawResult.billingDocument) {
          results.rawResult.billingDocument.date = DateUtils.formatToChileanDateV2(
            results.rawResult.billingDocument.date
          );
          results.rawResult.billingDocument.value = `$${CurrencyUtils.formatPriceFromNumber(
            results.rawResult.billingDocument.value
          )}`;
        }
        if (results.rawResult.billingData?.pricing) {
          results.rawResult.billingData.pricing.paid_by_user = `$${CurrencyUtils.formatPriceFromNumber(
            results.rawResult.billingData.pricing.paid_by_user
          )}`;
          results.rawResult.billingData.pricing.price_mode = `$${CurrencyUtils.formatPriceFromNumber(
            results.rawResult.billingData.pricing.price_mode
          )}`;
        }
        console.log(results);
        return results;
      } else {
        return { status: 'error', message: 'Failed to fetch DonGraf data' };
      }
    } catch (err) {
      console.error('DonGrafServices.get error', err);
      return { status: 'error', message: err?.message ? err.message : String(err) };
    }
  }
}
